import { createContext } from 'react';

const PayProgramContext = createContext();

export default PayProgramContext;
